export default function Oven() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <g clipPath="url(#clip0_3838_31585)">
                <path
                    d="M27.75 4.5H8.25C7.42157 4.5 6.75 5.17157 6.75 6V30C6.75 30.8284 7.42157 31.5 8.25 31.5H27.75C28.5784 31.5 29.25 30.8284 29.25 30V6C29.25 5.17157 28.5784 4.5 27.75 4.5Z"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10.125 7.875H13.5" stroke="#707070" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="24.75" cy="7.875" r="1.125" fill="#707070" />
                <path
                    d="M24.375 14.625H11.625C10.7966 14.625 10.125 15.2966 10.125 16.125V26.625C10.125 27.4534 10.7966 28.125 11.625 28.125H24.375C25.2034 28.125 25.875 27.4534 25.875 26.625V16.125C25.875 15.2966 25.2034 14.625 24.375 14.625Z"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.7375 18L15.6396 19.2887C16.0288 19.8447 15.9627 20.5998 15.4828 21.0797V21.0797C14.9906 21.5719 14.9352 22.3511 15.3528 22.9079L16.3125 24.1875"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                />
                <path
                    d="M19.2375 18L20.1396 19.2887C20.5288 19.8447 20.4627 20.5998 19.9828 21.0797V21.0797C19.4906 21.5719 19.4352 22.3511 19.8528 22.9079L20.8125 24.1875"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                />
                <path d="M6.75 11.25H29.25" stroke="#707070" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_3838_31585">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
